import { Badge } from '@/components/ui/Badge';
import { Button } from '@/components/ui/Button';
import { Card, CardContent } from '@/components/ui/Card';
import { Modal } from '@/components/ui/Modal';
import { Skeleton } from '@/components/ui/Skeleton';
import { EmptyState } from '@/components/ui/EmptyState';
import { useAdminAnnouncements, useDeleteAnnouncement } from '@/hooks/useAdminCommunications';
import { formatDateTime } from '@/utils/formatters';
import { Megaphone, Plus, Trash2 } from 'lucide-react';
import { useState } from 'react';
import { AnnouncementEditor } from '../components/AnnouncementEditor';
import { BannerPreview } from '../components/BannerPreview';

export function AnnouncementsPage() {
  const [showCreate, setShowCreate] = useState(false);
  const { data, isLoading } = useAdminAnnouncements({});
  const deleteAnn = useDeleteAnnouncement();
  const announcements = data?.data?.data || [];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div><h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Annonces</h1><p className="text-sm text-neutral-500">Gestion des annonces plateforme</p></div>
        <Button icon={<Plus className="h-4 w-4" />} onClick={() => setShowCreate(true)}>Nouvelle annonce</Button>
      </div>

      {isLoading ? <Skeleton className="h-64" /> : announcements.length === 0 ? (
        <EmptyState message="Aucune annonce" icon={<Megaphone className="h-10 w-10" />} action={<Button size="sm" onClick={() => setShowCreate(true)}>Créer une annonce</Button>} />
      ) : (
        <div className="space-y-3">
          {announcements.map((a) => (
            <Card key={a.uuid}>
              <CardContent>
                <div className="flex items-start justify-between mb-3">
                  <div>
                    <h3 className="font-medium text-neutral-900 dark:text-neutral-200">{a.title}</h3>
                    <p className="text-xs text-neutral-500 mt-1">{formatDateTime(a.startsAt)}{a.endsAt ? ` - ${formatDateTime(a.endsAt)}` : ''}</p>
                  </div>
                  <div className="flex items-center gap-2">
                    <Badge variant={a.isActive ? 'success' : 'neutral'}>{a.isActive ? 'Active' : 'Inactive'}</Badge>
                    <Button variant="ghost" size="sm" icon={<Trash2 className="h-3.5 w-3.5 text-danger-500" />} onClick={() => deleteAnn.mutate(a.uuid)} />
                  </div>
                </div>
                <BannerPreview title={a.title} type={a.type} />
              </CardContent>
            </Card>
          ))}
        </div>
      )}

      <Modal isOpen={showCreate} onClose={() => setShowCreate(false)} title="Nouvelle annonce" size="lg">
        <AnnouncementEditor onSuccess={() => setShowCreate(false)} />
      </Modal>
    </div>
  );
}
